import useWaitingMutation from '@hooks/useWaitingMutation';
import { SubmissionSubmitCommand } from 'apps/publisher-v3.ui.customer/src/features/submission/types';
import { submitSubmission } from '@common/services/submissionService';

export const useSubmitSubmission = (submissionId: string) => {
  const { mutate } = useWaitingMutation((payload: SubmissionSubmitCommand) => submitSubmission(submissionId, { ...payload }));

  return { submitSubmission: mutate };
};
